<template>
  <TextButton small class="px-0" @click="handleClick">
    <FavoriteIcon :on="applicant.favorite" />
  </TextButton>
</template>

<script>
import TextButton from "@/components/atoms/TextButton";
import FavoriteIcon from "@/components/atoms/FavoriteIcon";
import ApiMixin from "@/ApiMixin";
import {mapGetters} from "vuex";
export default {
  mixins: [ApiMixin],
  name: "ApplicantFavoriteAddButton",
  components: {FavoriteIcon, TextButton},
  props: {
    applicant: {
      type: Object
    }
  },
  computed: {
    ...mapGetters("client", ["company"])
  },
  methods: {
    handleClick() {
      if (this.applicant.favorite) {
        this.deleteChatRequestListApplicant(this.company.id, this.applicant.id, "favorite")
      } else {
        this.addChatRequestListApplicant(this.company.id, this.applicant.id, "favorite")
      }
    }
  }
}
</script>

<style scoped>

</style>
